document.addEventListener('DOMContentLoaded', function () {
  const rails = document.querySelectorAll('[data-auto-scroll]');
  rails.forEach((rail) => {
    let step = 1;
    let active = true;
    rail.addEventListener('mouseenter', () => active = false);
    rail.addEventListener('mouseleave', () => active = true);
    setInterval(() => {
      if (!active || rail.scrollWidth <= rail.clientWidth) return;
      rail.scrollLeft += step;
      if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2) rail.scrollLeft = 0;
    }, 28);
  });
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const mainImage = root.querySelector('[data-product-main-image]');
    const thumbs = root.querySelectorAll('[data-product-thumb]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-image');
        if (mainImage && src) mainImage.src = src;
        thumbs.forEach((btn) => btn.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const variantScript = root.querySelector('[data-variants-json]');
    const variantInput = root.querySelector('[data-variant-id]');
    const selects = Array.from(root.querySelectorAll('[data-option-select]'));
    const priceEl = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-to-cart-button]');
    let variants = [];

    if (variantScript) {
      try { variants = JSON.parse(variantScript.textContent); } catch (error) { variants = []; }
    }

    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(amount);
    };

    const updateVariant = () => {
      if (!variants.length || !selects.length) return;
      const selected = selects.map((select) => select.value);
      const variant = variants.find((item) => {
        return item.options && item.options.length === selected.length && item.options.every((option, index) => option === selected[index]);
      });
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (mainImage && variant.image) mainImage.src = variant.image;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    };

    root.querySelectorAll('[data-swatch-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const optionIndex = Number(button.getAttribute('data-option-index'));
        const value = button.getAttribute('data-option-value');
        const select = selects[optionIndex];
        if (!select || !value) return;

        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        root.querySelectorAll(`[data-swatch-button][data-option-index="${optionIndex}"]`).forEach((btn) => btn.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });

    selects.forEach((select, index) => {
      select.addEventListener('change', () => {
        root.querySelectorAll(`[data-swatch-button][data-option-index="${index}"]`).forEach((button) => {
          button.classList.toggle('is-active', button.getAttribute('data-option-value') === select.value);
        });
        updateVariant();
      });
    });

    updateVariant();
  });
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-rotating-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    if (slides.length <= 1) return;

    const interval = Number(gallery.getAttribute('data-interval') || 5000);
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    const showSlide = (nextIndex) => {
      slides[index].classList.remove('is-active');
      index = nextIndex % slides.length;
      slides[index].classList.add('is-active');
    };

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    setInterval(() => {
      showSlide(index + 1);
    }, interval);
  });
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-card-rotator]').forEach((rotator) => {
    const items = Array.from(rotator.querySelectorAll('.rotator-item'));
    if (items.length <= 4) return;

    const interval = Number(rotator.getAttribute('data-interval') || 5000);
    const getGroupSize = () => {
      if (window.matchMedia('(max-width: 620px)').matches) return 1;
      if (window.matchMedia('(max-width: 1100px)').matches) return 2;
      return 4;
    };

    let start = 0;

    const showGroup = () => {
      const groupSize = getGroupSize();
      items.forEach((item) => item.classList.remove('is-active'));
      for (let i = 0; i < groupSize; i += 1) {
        const index = (start + i) % items.length;
        items[index].classList.add('is-active');
      }
    };

    showGroup();

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    setInterval(() => {
      start = (start + getGroupSize()) % items.length;
      showGroup();
    }, interval);

    window.addEventListener('resize', showGroup);
  });
});
